var map = {
	"./book-bg.png": 36,
	"./paper-texture.jpg": 37,
	"./paper-towel-texture.jpg": 38,
	"./svg-sprite/icon-chevron-colored.svg": 39,
	"./svg-sprite/icon-chevron.svg": 40,
	"./svg-sprite/icon-facebook.svg": 41,
	"./svg-sprite/icon-instagram.svg": 42,
	"./svg-sprite/icon-show-score.svg": 43,
	"./svg-sprite/icon-twitter.svg": 44,
	"./svg-sprite/icon-youtube.svg": 45
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35;